import React, { useEffect, useState } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ERouteLinks } from 'models/route';
import { ActionTypes } from 'state/actions/alert';
import { Alert } from 'components/atoms/Alert';
import { useAlert } from 'models/alertContext';
import { Box } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { ILicenceTemplateApplicationProcessForm } from 'models/licenceConfigurator';
import { useParams } from 'react-router-dom';
import { initialFormValuesApplicationProcess } from '../helper';
import { FormLicenceTemplateApplicationProcessPage } from '../FormLicenceTemplateApplicationProcessPage';

const LicenceTemplateAddApplicationProcessPage = () => {
  const { clearAlert, samePageAlert } = useAlert();
  const { t } = useTranslations();
  const { id = '' } = useParams<{ id: string }>();
  const [formValues, setFormValues] = useState<ILicenceTemplateApplicationProcessForm>();

  useEffect(() => {
    if (!formValues) {
      setFormValues(initialFormValuesApplicationProcess);
    }
  }, [id]);

  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_SAME_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <>
      <Breadcrumbs
        items={[
          {
            label: t('module.administration.name'),
            route: ERouteLinks.Administration,
          },
          {
            label: t('licenceConfiguration.header'),
            route: ERouteLinks.LicenceConfigurationPage,
          },
          {
            label: t('licenceConfiguration.detail.header'),
            route: ERouteLinks.LicenceTemplatePage.replace(':id', id),
          },
          t('licenceConfiguration.applicationProcess.add.header'),
        ]}
      />
      <StyledPageTitle variant="h4">
        {t('licenceConfiguration.applicationProcess.add.header')}
      </StyledPageTitle>

      {samePageAlert && (
        <Box sx={{ my: 2 }}>
          <Alert text={samePageAlert.text} variant={samePageAlert.variant} />
        </Box>
      )}
      {formValues && (
        <FormLicenceTemplateApplicationProcessPage
          initialFormValues={formValues}
          licenceTemplateUniqueId={id}
        />
      )}
    </>
  );
};

export { LicenceTemplateAddApplicationProcessPage };
